import * as e from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/Basket.es.js";
const o = e.forwardRef((t, a) => /* @__PURE__ */ e.createElement(r, { ref: a, ...t, weights: s }));
o.displayName = "BasketIcon";
const n = o;
export {
  n as Basket,
  o as BasketIcon
};
